export enum ViewFollowsScreenToggleState {
  FOLLOWING = 'FOLLOWING',
  FOLLOWERS = 'FOLLOWERS',
}

export enum ViewPlanScreenToggleState {
  JOINED = 'JOINED',
  GROUPS = 'GROUPS',
  PHOTOS = 'PHOTOS',
  COMMENTS = 'COMMENTS',
  NOTES = 'NOTES',
  LIKES = 'LIKES',
  MAP = 'MAP',
}
